import { Membership, Team } from "@/teams";
import { Action, Store } from "vuex";
import {
    namespace,
    TeamsState,
    MembershipData,
    DeleteManagerData,
    AddManagerData,
    AddTeamData,
    ActionResult,
    UpdateTeamData
} from "../modules/teams/teams";
// import { Teams} from "@infoland/iprova-api";

export class TeamsStore {
    private store: Store<any>;

    constructor(store: Store<TeamsState>) {
        this.store = store;
    }

    /** Gets the teams */
    public get teams(): Team[] {
        return this.store.getters[`${namespace}/teams`];
    }

    public async loadTeamsAsync(): Promise<void> {
        await this.store.dispatch(`${namespace}/loadTeams`);
    }

    public async createTeamAsync(
        name: string,
        description: string,
        memberships: Membership[],
        manager_ids: string[]
    ): Promise<ActionResult<string, number>> {
        return await this.store.dispatch(`${namespace}/createTeam`, <AddTeamData>{ name, description, memberships, manager_ids });
    }

    public async updateLastVisited(team_id: string): Promise<void> {
        await this.store.dispatch(`${namespace}/updateLastVisited`, team_id);
    }

    public async updateTeam(team_id: string, name: string, description: string): Promise<ActionResult<void, string>> {
        return await this.store.dispatch(`${namespace}/updateTeam`, <UpdateTeamData>{ team_id, name, description });
    }

    public async deleteTeam(team_id: string): Promise<ActionResult<void, string>> {
        return await this.store.dispatch(`${namespace}/deleteTeam`, team_id);
    }

    public async deleteMembership(team_id: string, user_id: string, user_group_id): Promise<ActionResult<void, string>> {
        return await this.store.dispatch(`${namespace}/deleteMembership`, <MembershipData>{
            team_id: team_id,
            memberships: [{ user_id: user_id, user_group_id: user_group_id, name: null }]
        });
    }

    public async addMembership(teamID: string, userID: string, userGroupID: string): Promise<ActionResult<void, string>> {
        return await this.store.dispatch(`${namespace}/addMembership`, <MembershipData>{
            team_id: teamID,
            memberships: [{ user_id: userID, user_group_id: userGroupID, name: null }]
        });
    }

    public async deleteManager(teamID: string, managerID: string): Promise<ActionResult<void, string>> {
        return await this.store.dispatch(`${namespace}/deleteManager`, <DeleteManagerData>{ team_id: teamID, managers: [managerID] });
    }

    public async addManager(teamID: string, managerID: string): Promise<ActionResult<void, string>> {
        return await this.store.dispatch(`${namespace}/addManager`, <AddManagerData>{
            team_id: teamID,
            managers: [managerID]
        });
    }
}
